import { defineComponent } from 'vue';
import utils from '@utils/index';
export default defineComponent({
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        size: {
            type: String,
            default: 'normal'
        }
    },
    methods: {
        toDetail(item) {
            // TODO h5 pbl 暂时未上线
            if (utils.isApp()) {
                utils.postMessage({
                    type: 'pbl_detail',
                    id: item.albumId
                });
            }
        }
    }
});
